/**
 * Placeholder team rows use last name "Waiting" or names starting with "Waiting" — exclude from email To/BCC lists.
 */
export function isWaitingPlaceholderProviderLastName(lastName) {
  const s = String(lastName || '').trim().toLowerCase();
  return s.startsWith('waiting');
}
